import type { HelpFile } from '../../types/help'
import { WorkflowTimelineCardTestIds } from '../../../testids/WorkflowTimelineCardTestIds'

export const workflowTimelineCardHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rule-requests',
  texts: {
    [WorkflowTimelineCardTestIds.workflowTimelineCard]:
      'Lebenszyklus dieses Antrags — von Entwurf über Eingereicht bis zur abschließenden Entscheidung (Genehmigt, Abgelehnt oder Zurückgezogen).',
    [WorkflowTimelineCardTestIds.cardTitleWorkflowTimeline]: null,
    [WorkflowTimelineCardTestIds.workflowTimelineCreated]:
      'Zeitpunkt der Erstellung des Antragsentwurfs.',
    [WorkflowTimelineCardTestIds.workflowTimelineSubmitted]:
      'Zeitpunkt der Einreichung in den Genehmigungsworkflow.',
    [WorkflowTimelineCardTestIds.workflowTimelineApproved]:
      'Zeitpunkt der Genehmigung durch den/die zugewiesenen Prüfer.',
    [WorkflowTimelineCardTestIds.workflowTimelineRejected]:
      'Zeitpunkt der Ablehnung durch den zugewiesenen Prüfer.',
    [WorkflowTimelineCardTestIds.workflowTimelineCancelled]:
      'Zeitpunkt des Zurückziehens durch den Antragsteller vor einer Entscheidung.',
  },
}
